import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { getAccountStore } from '@/store/account/actions';

/**
 * @returns min and max dates for calendar in dateDropdown popover and FiltersPopover
 */
export const useMinMaxDate = (): string[] => {
    const { GeneralInfo } = useSelector(getAccountStore);
    const minDate = dayjs().startOf('day').utc().subtract(GeneralInfo.KeepLogsForDays, 'day').toJSON() as string;
    const maxDate = dayjs().startOf('day').utc().add(1, 'day').toJSON() as string;

    return [minDate, maxDate];
};
